import React, { useEffect, useState } from "react";
import "./Indivisiual.css";
import api from "../../utils/ApiMethod";
import { truncateAtWord } from "../../utils/constants";
import { motion } from "framer-motion";

import { Box, Flex, Text, Image } from "@chakra-ui/react";
import { Helmet } from "react-helmet";

const MotionBox = motion(Box);

const SecretarySportsDepartment = () => {
  const [harjotPageData, setHarjotPageData] = useState([]);

  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

  const paragraph = harjotPageData[0]?.paragraph ?? "";

  // Scale the message to its length so short messages don't look lost beside the photo
  const textLength = paragraph?.length ?? 0;
  const isShort = textLength < 350;
  const messageFontSize = isShort
    ? { base: "xl", md: "2xl", lg: "3xl" }
    : textLength < 700
    ? { base: "lg", md: "xl" }
    : { base: "md", md: "lg", lg: "xl" };

  const handleFetchData = async () => {
    try {
      const data = await api.fetchData("/harjot");
      // setHarjotPageData(data);
      setHarjotPageData(data.filter((item) => item.isActive ?? true));
      // console.log("Fetched data:", data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          दीपक आनंद | सचिव | खेल विभाग | BSSA
        </title>
        <meta
          name="description"
          // content="महेंद्र कुमार, सचिव, खेल विभाग बिहार सरकार का संदेश: बिहार खेल में नए आयाम स्थापित कर रहा है। सरकार खिलाड़ियों को उत्कृष्ट सुविधाएं और प्रोत्साहन देकर उनका सर्वांगीण विकास सुनिश्चित कर रही है।"
          // content="विनोद सिंह गुंज्याल, सचिव, खेल विभाग बिहार सरकार का संदेश: बिहार खेल में नए आयाम स्थापित कर रहा है। सरकार खिलाड़ियों को उत्कृष्ट सुविधाएं और प्रोत्साहन देकर उनका सर्वांगीण विकास सुनिश्चित कर रही है।"
          content="दीपक आनंद, सचिव, खेल विभाग बिहार सरकार का संदेश: बिहार खेल में नए आयाम स्थापित कर रहा है। सरकार खिलाड़ियों को उत्कृष्ट सुविधाएं और प्रोत्साहन देकर उनका सर्वांगीण विकास सुनिश्चित कर रही है।"
        />
      </Helmet>
      <Flex
        direction={{ base: "column", md: "row" }}
        align={{ base: "center", md: "stretch" }}
        gap={{ base: 6, md: 10 }}
        mt="20"
        mb="10"
        px={[5, 10, 20]}
      >
        <MotionBox
          flexShrink={0}
          w={{ base: "100%", md: "40%", lg: "35%" }}
          maxW="480px"
          display="flex"
          justifyContent="center"
          alignSelf={{ base: "center", md: "flex-start" }}
          position={{ md: "sticky" }}
          top={{ md: "100px" }}
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.3, delay: 1 }}
        >
          <Image
            borderRadius="lg"
            boxShadow="md"
            src={harjotPageData[0]?.image}
            alt="Sports Secretary"
            w="auto"
            h="auto"
            maxW="100%"
            maxH={{ base: "420px", md: "520px" }}
            objectFit="contain"
          />
        </MotionBox>

        <Flex
          flex="1"
          minW={0}
          w="100%"
          direction="column"
          justify={{ base: "flex-start", md: "center" }}
          alignSelf="stretch"
        >
          {/* Name + designation (same conventions as Ravindran.jsx) */}
          <Text
            fontWeight="bold"
            textTransform="uppercase"
            fontSize={["18", "42"]}
            letterSpacing="wide"
            color="teal.800"
          >
            {harjotPageData[0]?.title}
          </Text>
          <Text
            fontWeight="bold"
            textTransform="uppercase"
            align={"right"}
            fontSize={["10", "13"]}
            letterSpacing="wide"
            color="black"
          >
            {harjotPageData[0]?.designation}
          </Text>

          {/* Message */}
          <Box mt={2} py="2">
            <Text
              align={"left"}
              color="gray.500"
              fontSize={messageFontSize}
              lineHeight={isShort ? "taller" : "tall"}
              letterSpacing="wide"
              fontWeight="bold"
            >
              {expanded || textLength <= 850
                ? paragraph
                : `${truncateAtWord(paragraph, 850)}...`}
            </Text>
            {textLength > 850 && (
              <button
                onClick={toggleExpand}
                style={{ color: "blue", fontWeight: "500" }}
              >
                {expanded ? "कम पढ़ें" : "और पढ़ें"}
              </button>
            )}
          </Box>
        </Flex>
      </Flex>
    </>
  );
};
export default SecretarySportsDepartment;
